import { Flow, Heading } from 'bold-ui'
import { CidadaoFamiliaCard } from 'view/cadastro-imovel/components/CidadaoFamiliaCard'
import { VisualizarCidadaoButton } from 'view/visualizacao-imovel/components/VisualizarCidadaoButton'
import { convertCidadaoTerritorioToCidadaoCard } from 'view/visualizacao-imovel/visualizacao-imovel-converter'
import { getResponsavelDependentesFamilia } from 'view/visualizacaoTerritorial/utils/visualizacaoTerritorialUtils'

import { TerritorioMapaFamiliaResidenteModel } from '../model-territorioMapa'

interface PinoTerritorioModalFamiliaSectionProps {
  familiaResidente: TerritorioMapaFamiliaResidenteModel
}

export function PinoTerritorioModalFamiliaSection(props: Readonly<PinoTerritorioModalFamiliaSectionProps>) {
  const { familiaResidente } = props

  const { responsavel, dependentes } = getResponsavelDependentesFamilia(familiaResidente)

  return (
    <Flow direction='vertical' gap={0.75} key={familiaResidente.id}>
      <Heading level={5}>
        Prontuário familiar:{' '}
        {familiaResidente.numeroProntuarioFamiliar ? familiaResidente.numeroProntuarioFamiliar : 'Não informado'}
      </Heading>
      {responsavel && (
        <CidadaoFamiliaCard
          variant='minified'
          cidadao={convertCidadaoTerritorioToCidadaoCard(responsavel)}
          isResponsavel
          possuiFichaNaoProcessada={responsavel.ultimaFichaCadastrada?.isProcessado !== true}
          buttonComponent={
            <VisualizarCidadaoButton cidadaoId={responsavel.id} prontuarioId={responsavel?.prontuario?.id} />
          }
        />
      )}
      {dependentes
        .filter((cidadao) => !cidadao.isFaleceu && cidadao.id !== responsavel?.id)
        .map((cidadao) => {
          return (
            <CidadaoFamiliaCard
              variant='minified'
              key={cidadao.id}
              cidadao={convertCidadaoTerritorioToCidadaoCard(cidadao)}
              isResponsavel={false}
              possuiFichaNaoProcessada={cidadao.ultimaFichaCadastrada?.isProcessado !== true}
              buttonComponent={
                <VisualizarCidadaoButton cidadaoId={cidadao.id} prontuarioId={cidadao?.prontuario?.id} />
              }
            />
          )
        })}
    </Flow>
  )
}
